"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requiredClasses = exports.labelClasses = exports.helperClasses = exports.errorClasses = exports.clickableLabelClasses = exports.backdropClasses = void 0;
var _classVarianceAuthority = require("class-variance-authority");
var labelClasses = exports.labelClasses = (0, _classVarianceAuthority.cva)(['font-medium', 'text-base', 'select-none'], {
  variants: {
    disabled: {
      "true": ['text-black/40'],
      "false": []
    },
    error: {
      "true": [],
      "false": []
    }
  },
  compoundVariants: [{
    disabled: false,
    error: false,
    className: ['text-gray-700']
  }, {
    disabled: false,
    error: true,
    className: ['text-danger']
  }]
});
var clickableLabelClasses = exports.clickableLabelClasses = (0, _classVarianceAuthority.cva)(['select-none'], {
  variants: {
    disabled: {
      "true": ['text-black/40', 'cursor-not-allowed'],
      "false": ['text-gray-700', 'cursor-pointer']
    }
  }
});
var requiredClasses = exports.requiredClasses = (0, _classVarianceAuthority.cva)(['inline', 'font-medium', 'pl-1'], {
  variants: {
    disabled: {
      "true": ['text-black/40'],
      "false": ['text-danger']
    }
  }
});
var helperClasses = exports.helperClasses = (0, _classVarianceAuthority.cva)(['text-sm'], {
  variants: {
    disabled: {
      "true": ['text-black/40'],
      "false": ['text-gray-700']
    }
  }
});
var errorClasses = exports.errorClasses = (0, _classVarianceAuthority.cva)(['text-sm', 'text-danger']);
var backdropClasses = exports.backdropClasses = (0, _classVarianceAuthority.cva)(['z-[-1]', 'fixed', 'inset-0', 'transition', 'bg-black', 'bg-opacity-50', 'backdrop-filter', 'backdrop-blur-sm']);